import React,{useState, useEffect, useRef, useLayoutEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { COOKIESPREFIX } from '../config';
import Nav from '../components/Nav'
//screens
//

function App({gameState}) {
  const navigate = useNavigate();
  const [cookies, setCookie, removeCookie] = useCookies([`@${COOKIESPREFIX}_token`]);
  const [isNavOpen, setIsNavOpen] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)
  useEffect(() => {
  },[])
  function going(){
    if(cookies[`@${COOKIESPREFIX}_token`])return navigate('/usertype')
    navigate('/verify')
  }

  const topRef= useRef(null)
  useLayoutEffect(()=>{
      setTimeout(()=>{
        if(topRef?.current)
         topRef.current.scrollIntoView();
      },500)
  },[])


  return (
    <div className="flex flex-col items-center w-[100%] h-[100%] overflow-y-auto">
      <div ref={topRef}/>
      <div className='relative w-full'>
        <div onClick={() => setIsNavOpen(true)} className='w-[9%] h-[3%] top-[10%] left-[84%] absolute flex flex-col items-center justify-between' style={{zIndex:999}}>
          <div className='h-[4px] w-full bg-[#baa05a] rounded-full'></div>
          <div className='h-[4px] w-full bg-[#baa05a] rounded-full'></div>
          <div className='h-[4px] w-full bg-[#baa05a] rounded-full'></div>
        </div>
        <Nav closeNav={() => setIsNavOpen(false)} isNavOpen={isNavOpen}/>
        <div style={{ position: 'relative', top:0, left:0 }}>
            {/* <video style={{ position: 'absolute', top: 0, left: 0, zIndex: 0 }} loop={true} muted={true} controls={false} autoPlay playsInline src='/bgloopv2.mp4' /> */}
            <img onLoad={() => setIsLoaded(true)} src={'/images/rulesbg.png'} className='w-full' style={{ position: 'relative', zIndex: 10, top:0 }} alt="Background Image" />
        </div>
        {isLoaded && <div style={{zIndex:998}} className='absolute top-0 left-0 w-full h-full'>
          <div className='absolute top-[43%] w-[100%] h-[25%] flex flex-col items-center justify-between px-[10%]'>
            <div className='flex flex-row items-center justify-center'>
              <img src='./images/rules1.png' className='w-[20%]'></img>
              <div className='text-[14px] font-[500] text-[#3e7caf]'>
                從4個不同類型的購物達人中，挑選最適合您的一個。
              </div>
            </div>
            <div className='flex flex-row items-center justify-center'>
              <img src='./images/rules2.png' className='w-[20%]'></img>
              <div className='text-[14px] font-[500] text-[#3e7caf]'>
                到達指定的樓層，掃描指定二維碼以完成任務。
              </div>
            </div>
            <div className='flex flex-row items-center justify-center'>
              <img src='./images/rules3.png' className='w-[20%]'></img>
              <div className='text-[14px] font-[500] text-[#3e7caf]'>
                {'到崇光啟德店地下G-10店(Longchamp對面)的'} <b onClick={()=>{navigate('/info')}} className='underline font-[400]'>中銀崇光活動專櫃</b> 領取專屬的禮品乙份。
              </div>
            </div>
            {/* <div className='absolute top-[36%] w-[60%] ml-[16%] text-[14px] font-[500] text-[#3e7caf]'>
              到達指定的樓層，掃描指定二維碼以完成任務。
            </div>
            <div className='absolute top-[71%] w-[60%] ml-[16%] text-[14px] font-[500] text-[#3e7caf]' style={{whiteSpace:'wrap'}}>
              {'到崇光啟德店地下G-10店(Longchamp對面)的'} <b onClick={()=>{navigate('/info')}} className='underline font-[400]'>中銀崇光活動專櫃</b> 領取專屬的禮品乙份。
            </div> */}
          </div>
          <img src='/images/start_button.png' className='w-[70%] absolute left-[15%] top-[69%] cursor-pointer' style={{zIndex:97}} onClick={() => going()}/>
        </div>}
      </div>
    </div>
  );
}

export default App;